export enum CalendarStatus {
    NotScheduled = 'Not Scheduled',
    Scheduled = 'Scheduled',
    InProgress = 'In Progress',
    Canceled = 'Canceled',
    Completed = 'Completed',
}

export interface Calendar {
    status: CalendarStatus;
    start_time: string;
    end_time: string;
    schedule_url: string;
    reschedule_url: string;
    cancel_url: string;
}

interface CalendlyLinks {
    intro: Calendar;
    kickoff: Calendar;
    training: Calendar;
    offboarding: Calendar;
    mrm: Calendar;
    em: Calendar;
}

export interface SpecialistCalendlyLink {
    role_name: string;
    specialist_name: string;
    calendars: CalendlyLinks;
    image_url: string;
}
